import React, { useState } from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaLock,
  FaCertificate,
  FaHandsHelping,
  FaGlobeAsia,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { INSTAGRAM_URL, FACEBOOK_URL } from "../../constants/socialLinks";
import { useHiddenCategories } from "../../api/hiddenCategories";
import logo from "../../assets/images/Logo-New.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const Footer = () => {
  const { isCategoryHidden } = useHiddenCategories();
  const data = [
    {
      icon: <FaLock />,
      title: "SECURE PAYMENT",
      text: "Encrypted & Safe Checkout",
    },
    {
      icon: <FaCertificate />,
      title: "ISO 9001 COMPLIANT OPERATION",
      text: "Certified. Verified. Trusted.",
    },
    {
      icon: <FaHandsHelping />,
      title: "CONSUMER-CENTRIC CARE",
      text: "Designed with your well-being and transformation in mind.",
    },
    {
      icon: <FaGlobeAsia />,
      title: "SAFE AND SECURE SHIPPING",
      text: "Encrypted & Safe Checkout",
    },
  ];
  const [active, setActive] = useState("");
  const toggleAccordion = (section) => {
    setActive(active === section ? "" : section);
  };
  return (
    <>
      <section className="astroFooterTop">
        <Swiper
          className="astroFooterTopContainer"
          modules={[Autoplay]}
          spaceBetween={30}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            577: {
              slidesPerView: 4,
            },
          }}
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="astroFooterCard">
                <div className="astroFooterIcon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <footer className="astroFooter">
        <div className="astroFooterContainer">
          <div className="astroFooterCol">
            <img
              src={logo}
              alt="Astro Logical Solutions"
              className="astroFooterLogo"
            />

            <p>
              Founded by Maniesh RK Sharma, Astro Logical Solutions specializes
              in authentic Rudraksha, Gemstones,Vastu products, Pooja
              Essentials, delivering trusted spiritual solutions across India.
            </p>
          </div>
          <div className="astroFooterCol astroMobileAccordion">
            <div
              className="astroAccordionTitle"
              onClick={() => toggleAccordion("category")}
            >
              <h3>Category</h3>
            </div>

            <ul
              className={`astroAccordionContent ${
                active === "category" ? "open" : ""
              }`}
            >
              {!isCategoryHidden("rudrakshas") && (
                <li>
                  <Link to="/shop/rudrakshas">Rudrakshas</Link>
                </li>
              )}

              {!isCategoryHidden("rudrakshas") && (
                <li>
                  <Link to="/rudraksha-calculator">Rudraksha Calculator</Link>
                </li>
              )}

              {!isCategoryHidden("gemstones") && (
                <li>
                  <Link to="/shop/gemstones">Gemstones</Link>
                </li>
              )}

              {!isCategoryHidden("crystals") && (
                <li>
                  <Link to="/shop/crystals">Crystals & Healing Stones</Link>
                </li>
              )}

              {!isCategoryHidden("shankh-sea-shells") && (
                <li>
                  <Link to="/shop/shankh-sea-shells">Shankh & Sea Shells</Link>
                </li>
              )}

              {!isCategoryHidden("vastu-products") && (
                <li>
                  <Link to="/shop/vastu-products">Vastu Shashtra</Link>
                </li>
              )}

              {!isCategoryHidden("pooja") && (
                <li>
                  <Link to="/shop/pooja">Pooja Essentials</Link>
                </li>
              )}

              {!isCategoryHidden("tulsi") && (
                <li>
                  <Link to="/shop/tulsi">Tulsi Product</Link>
                </li>
              )}
            </ul>
          </div>

          <div className="astroFooterCol astroMobileAccordion">
            <div
              className="astroAccordionTitle"
              onClick={() => toggleAccordion("information")}
            >
              <h3>Information</h3>
            </div>
            <ul
              className={`astroAccordionContent ${
                active === "information" ? "open" : ""
              }`}
            >
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/refund-Policy">Refund Policy</Link>
              </li>
              <li>
                <Link to="/Shipping-Policy">Shipping Policy</Link>
              </li>
              <li>
                <Link to="/consultation-policy">Consultation Policy</Link>
              </li>
              <li>
                <Link to="/mobile-numerology-policy">
                  Mobile Numerology Policy
                </Link>
              </li>
              <li>
                <Link to="/website-disclaimer">Website Disclaimer</Link>
              </li>
            </ul>
          </div>
          <div className="astroFooterCol astroMobileAccordion">
            <div
              className="astroAccordionTitle"
              onClick={() => toggleAccordion("contact")}
            >
              <h3>Contact Us</h3>
            </div>
            <div
              className={`astroAccordionContent ${
                active === "contact" ? "open" : ""
              }`}
            >
              <div className="astroContactBox">
                <p>
                  <FaEnvelope className="astroContactIcon" />
                  support@astrologicalsolutions.in
                </p>
                {/* <p>
                  <FaPhoneAlt className="astroContactIcon" />
                  7351519573
                </p> */}
                {/* <p>
                  <FaPhoneAlt className="astroContactIcon" />
                  7351739191
                </p> */}
                <p>
                  <FaMapMarkerAlt className="astroContactIcon" />
                  Shiva Aangan, Bachan Singh Colony, Lane No.9, Muzaffarnagar,
                  Uttar Pradesh, 251001
                </p>
              </div>
            </div>
          </div>
          <div className="astroFooterCol astroMobileAccordion">
            <div
              className="astroAccordionTitle"
              onClick={() => toggleAccordion("follow")}
            >
              <h3>Follow Us</h3>
            </div>

            <div
              className={`astroAccordionContent ${
                active === "follow" ? "open" : ""
              }`}
            >
              <div className="astroSocialIcons">
                <a
                  href={FACEBOOK_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>

                <a href="/">
                  <FaTwitter />
                </a>

                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>

                <a href="/">
                  <FaYoutube />
                </a>
              </div>

              <h4 className="astroNewsletterTitle">Join Our Newsletter Now</h4>

              <div className="astroNewsletter">
                <input type="email" placeholder="Your email address..." />

                <button>SUBSCRIBE</button>
              </div>
            </div>
          </div>
        </div>

        <h3 className="astroCopyright">
          Copyright © 2026 - support@astrologicalsolutions.in - All Rights
          Reserved
        </h3>
      </footer>
         <a
        href="https://api.whatsapp.com/send/?phone=917351739191&text=Hello+Astro+Logical+Solutions%2C+I+would+like+some+guidance.&type=phone_number&app_absent=0"
        className="atelier-btn"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Ask Astro-Logical on WhatsApp"
      >
        <span className="chat-icon">
          ♧
        </span>

        <span className="atelier-text">
        Ask Astro-Logical
        </span>

        <span className="atelier-arrow">→</span>
        <img
          src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1793266238/chat-bead_jdckha.png"
          alt=""
        />
      </a>
    </>
  );
};

export default Footer;
